import { render } from "./ChatListing.vue?vue&type=template&id=6c99e1aa&scoped=true&ts=true"
import script from "./ChatListing.vue?vue&type=script&lang=ts"
export * from "./ChatListing.vue?vue&type=script&lang=ts"

import "./ChatListing.vue?vue&type=style&index=0&id=6c99e1aa&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c99e1aa"]])

export default __exports__